import * as i0 from "@angular/core";
const _c0 = ["ycn-notifications-menu-report-history-item", ""];
export class NotificationsMenuReportHistoryItemComponent {
    constructor() {
        this.reportDate = '';
    }
    ngOnInit() {
        this.reportDate = new Date(this.report.create_date).toLocaleString('default', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        });
    }
}
NotificationsMenuReportHistoryItemComponent.ɵfac = function NotificationsMenuReportHistoryItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationsMenuReportHistoryItemComponent)(); };
NotificationsMenuReportHistoryItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationsMenuReportHistoryItemComponent, selectors: [["tr", "ycn-notifications-menu-report-history-item", ""]], inputs: { report: "report" }, standalone: false, attrs: _c0, decls: 7, vars: 2, consts: [[1, "notification-title", "unread"], [1, "bullet", "bullet-blue"], [1, "notification-date"]], template: function NotificationsMenuReportHistoryItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "td")(1, "div", 0);
        i0.ɵɵelement(2, "div", 1);
        i0.ɵɵelementStart(3, "span");
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 2);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.report.title);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.reportDate);
    } }, encapsulation: 2 });
